// extracted by mini-css-extract-plugin
export default {"containerWrapper":"PageLayoutWithNavMenu_containerWrapper__j7aNj","reducedHeight":"PageLayoutWithNavMenu_reducedHeight__rFFyg"};